import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import toast from 'react-hot-toast';
import { FiFileText, FiLink } from 'react-icons/fi';
import { Loader } from '@/components/custom/loader';
import { ComplementaryActivityEvaluationCardHeader } from '@/pages/complementary-activity/complementary-activity-evaluation/complementary-activity-evaluation-card-header';
import { useTranslation } from 'react-i18next';
import { DashboardContent } from '@/layouts/dashboard';
import { PageContent, Page, PageSidebar } from '@/components/custom/page';
import { ActivityCardBody, ActivityCardHeaderContent, ActivityCardInfo, ActivityCardSubtitle, ActivityCardHeader, ActivityCardDescription } from '@/components/custom/activity';
import { Button } from '@/components/ui/button';
import { CardIcon } from '@/components/ui/card';

export default function ComplementaryActivityEvaluationViewDefault(props) {
  const { uri } = props;

  const { t } = useTranslation();
  const client = useClient();
  const [isLoading, setIsLoading] = useState(true);
  const [activity, setActivity] = useState();
  const [activityStudent, setActivityStudent] = useState();

  useEffect(() => {
    getActivity();
    getActivityStudent();
  }, []);

  const getActivity = async () => {
    try {
      setIsLoading(true);
      const { data } = await client.fetch(['activities', props.activityId]);
      setActivity(data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      toast.error(t('toast.errorGetActivity'));
    }
  };

  const getActivityStudent = async () => {
    try {
      setIsLoading(true);
      const { data } = await client.fetch(['activities', props.activityId, 'activity_students', props.id]);
      setActivityStudent(data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
      toast.error(t('toast.errorGetActivityStudent'));
    }
  };

  const breadcrumbs = {
    title: 'Atividades',
    nav: [
      {
        route: '/atividade-complementar',
        name: 'Atividade Complementar',
        isActive: false
      },
      {
        route: uri,
        name: activity?.title,
        isActive: false
      },
      {
        route: '/atividade-complementar',
        name: 'Avaliação do professor',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <Page>
        {isLoading || !activity || !activityStudent ? (
          <Loader />
        ) : (
          <PageContent
            bg
            className="gap-0"
          >
            <ComplementaryActivityEvaluationCardHeader
              activity={activity}
              activityStudent={activityStudent}
              showStatus
            />

            <ActivityCardBody>
              {activityStudent.comments.map(comment => (
                <React.Fragment key={comment?.id}>
                  <ActivityCardHeader>
                    <ActivityCardHeaderContent>
                      <ActivityCardSubtitle>{comment.user.includes('Aluno') ? t('activity.titleStudentAnswer') : t('activity.teacherEvaluation')}</ActivityCardSubtitle>
                      <ActivityCardInfo>
                        {t('activity.in')} {moment(comment['created-at']).format(t('datesForm.formatDate'))}
                      </ActivityCardInfo>
                    </ActivityCardHeaderContent>

                    {comment.user.includes('Aluno') && activityStudent['activity-file'] !== null && (
                      <Button
                        variant="link"
                        asChild
                      >
                        <a
                          href={activityStudent['activity-file']?.url || activityStudent['activity-file']?.file}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <CardIcon>{activityStudent['activity-file']?.url ? <FiFileText /> : <FiLink />}</CardIcon>
                          {activityStudent['activity-file']?.url ? t('activity.sendUrl') : t('activity.sendFiles')}
                        </a>
                      </Button>
                    )}
                  </ActivityCardHeader>

                  <ActivityCardDescription>{comment.body}</ActivityCardDescription>
                </React.Fragment>
              ))}

              <ActivityCardHeader>
                <ActivityCardHeaderContent>
                  <ActivityCardSubtitle>{t('activity.titleActivityDescription')}</ActivityCardSubtitle>
                  <ActivityCardInfo>
                    {t('activity.in')} {moment(activity['publish-at']).format(t('datesForm.formatDate'))}
                  </ActivityCardInfo>
                </ActivityCardHeaderContent>

                <Button
                  variant="outline"
                  asChild
                >
                  <a
                    href={activity['activity-file']?.url || activity['activity-file']?.file}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('button.supportMaterial')}
                  </a>
                </Button>
              </ActivityCardHeader>

              <ActivityCardDescription variant="plain">{activity.description}</ActivityCardDescription>
            </ActivityCardBody>
          </PageContent>
        )}

        <PageSidebar />
      </Page>
    </DashboardContent>
  );
}
